class WebComponentBase extends HTMLElement {

    static define(name, type) {
        window.customElements.define(name, type);
    }

    static get observedAttributes() {
        return ["id", "class", "style-id", "style"];
    }

    constructor(template, { shadowMode }) {
        super();

        this._shadow = this.attachShadow({
            mode: shadowMode || "closed"
        });

        //Template is a true template instance with content field.
        if (template.tagName === "TEMPLATE" && template.content !== undefined) {
            this._root = template.content.cloneNode(true);
        }
        //Template is a standard DOM element.
        else {
            this._root = template;
        }

        this._shadow.appendChild(this._root);
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue === newValue) {
            return false;
        }
        switch (name) {
            case "id":
                this.getRoot().id = newValue;
                break;
            case "class":
                updateClass(this.getRoot(), oldValue, newValue);
                break;
            case "style-id":
                updateStyle(this, newValue);
                break;
            case "style":
                this.getRoot().style = newValue;
                break;
            default:
                if (this.attributeChanged) {
                    return !!this.attributeChanged(name, oldValue, newValue);
                }
                return false;
        }
        return true;
    }

    getShadow() {
        return this._shadow;
    }

    getRoot() {
        return this._root;
    }

}

export default WebComponentBase;

function updateStyle(element, id) {
    if (element._style) {
        element._style.remove();
    }
    const style = document.getElementById(id);
    if (style) {
        element._style = style.cloneNode(true);
        element._shadow.appendChild(element._style);
    }
}

function updateClass(element, oldValue, newValue) {
    let value = element.className || "";
    if (oldValue) {
        element.className = value.replace(oldValue, newValue);
    }
    else if (value) {
        element.className = value + " " + newValue;
    }
    else {
        element.className = newValue;
    }
}
